import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ca8caaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "loading-cover"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_4 = ["src", "onClick"]

import { ImagePreview, Loading } from 'vant'
import { Ref, ref, withDefaults, watch, computed } from 'vue'
import { useImageGuidTransfer } from '@/compositions/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'CommonImagePreview',
  props: {
    guids: { default: () => [] },
    width: { default: 80 },
    height: { default: 80 }
  },
  setup(__props: any) {

const props = __props as { guids: string[], width: number, height: number };


const { getImageFullUrl } = useImageGuidTransfer()
const imgLoading = ref(false)
const imageList: Ref<
  Array<{
    url: string
  }>
> = ref([])
const imageStyle = computed(() => {
  return {
    width: `${props.width}px`,
    height: `${props.height}px`,
  }
})

watch(
  () => props.guids,
  () => {
    imageList.value = props.guids.map((item) => ({
      url: '',
    }))
    initImageList()
  },
  {
    immediate: true,
  }
)
function imagePreviewHandler(index: number) {
  ImagePreview({
    images: imageList.value.map((item) => item.url),
    startPosition: index,
  })
}
async function initImageList() {
  imgLoading.value = true
  try {
    const data = await getImageFullUrl(props.guids)
    console.log('data', data)
    imageList.value = props.guids.map((guid) => ({
      url: data[guid].url,
    }))
  } catch (error) {
    console.log('error', error)
  }
  imgLoading.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageList.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        style: _normalizeStyle(_unref(imageStyle))
      }, [
        (imgLoading.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_unref(Loading))
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("img", {
          src: item.url,
          alt: "",
          onClick: ($event: any) => (imagePreviewHandler(index))
        }, null, 8, _hoisted_4), [
          [_vShow, !imgLoading.value]
        ])
      ], 4))
    }), 128))
  ]))
}
}

})